'use strict';

window.constants = {
    // example: http://localhost:8001/api/
    "authServer": "https://casist2-test.panacom.sk/api/",
    // example: localhost:8001/api
    "applicationServer": "casist2-test.panacom.sk/api",
};
